export enum WaiverState {
  Inactive = 1,
  Active,
}
